export const environment = {
  api_url: __PYI_API_URL__
};


// WEBPACK FOOTER //
// ./app/javascript/product_search/app/environments/environment.ts